import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M17 4v12a4 4 0 0 1 -4 4h-2a4 4 0 0 1 -4 -4","key":"svg-0"}]]

const IconLetterJ = createReactComponent('outline', 'letter-j', 'LetterJ', __iconNode);

export default IconLetterJ;